import React, { useState, useEffect, useRef } from 'react'
import { Modal, Form, Input, Button, Row, Col, Pagination, message,Tabs } from 'antd'
import { Link } from 'react-router-dom'
import { AddTag } from '../../../../index'
import * as API from '../../../../../api'
import * as UTILS from '../../../../../utils'
import './index.less'
import { getContentType } from '../../../../../utils/global'
export type ContentSelectTypeValue = 'btn' | 'block' ;
const { TabPane } = Tabs

const ContentSelect = (props) => {
	const {
		handleContentSelectVisible,
		onSuccess,
		contentSelectVisible,
		onChange,
		type,
		rowNum,
		value,
		nameList,
		accepts, // 指定文件类型 扩展名
	} = props

	const [initialValues, setInitialValues]= useState({id: '', st_text_title: '', st_create_work: ''})
	const [contentList, setContentList]= useState([])
	const [pageTotal, setPageTotal]= useState(0)
	const [checkList, setCheckList]= useState([])
	const [defaultTabName, setDefaultTabName] = useState('图片')
	const [queryBody, setQueryBody]= useState({
		query:{
			bool: {
				filter: [{
					bool: {
						filter: {
							term: {
								is_del: '0'
							}
						}
					}
				},{
					bool: {
						filter: {
							term: {
								st_is_works: '0'
							}
						}
					}
				}]
			}
		},
		sort: [
			{
				st_update_time: {
					order: 'DESC'
				}
			},
			{
				st_create_time: {
					order: 'DESC'
				}
			}
		],
		pageNo: 1,
		size: rowNum * 3,
	})
	const [queryShould, setQueryShould] = useState({})
	const [idMap, setIdMap] = useState({})
	const tagAddRef = useRef()
	const formRef = useRef()
	const generateQueryShould = async (item) => {
		const nameMap = await getContentType('nameMap')
		const query = {bool: {should: [{bool: {filter: {term: {st_type: nameMap[item]}}}}]}}
		setQueryShould(query)
	}
	const init = async () =>  {
		const idMap = await getContentType('idMap')
		if(nameList.length > 0) {
			// 传入的内容形式 或的关系 生成
			// nameList.forEach(item => {
			// 	query.bool.should.push({bool: {filter: {term: {st_type: nameMap[item]}}}})
			// })
			generateQueryShould(nameList[0])
			setDefaultTabName(nameList[0])
		}
		setIdMap(idMap)
	}
	const onReset = () => {
		const initialValues =  {
			st_text_title: '',
			id: '',
			st_create_work: ''
		}
		setInitialValues(initialValues)
		tagAddRef.current.reset()
		formRef.current.setFieldsValue(initialValues)
	}
	const onCheck = async (e: React.MouseEvent, val: object) => {
		if (val.disabled) return
		const type = await getContentType('id', val['st_type'])
		console.log('val',val,'type',type)
		const newContentList = [...contentList]
		const newCheckList = [...checkList]
		newContentList.forEach((item: object, i) => {
			if(item['id'] === val['id']) {
				val['type'] = type
				if(!item['isCheck']) {
					newCheckList.push(val)
				} else {
					const index = newCheckList.indexOf(val)
					newCheckList.splice(index, 1)
				}
				item['isCheck'] = !contentList[i].isCheck
			}
		})
		// const checkList = []
		console.log('onCheck checkList',newCheckList)
		setContentList(newContentList)
		setCheckList(newCheckList)
	}
	const initCkeckList = () => {
		if(value) {
			const newContentList = [...contentList]
			const newCheckList = []
			newContentList.forEach((item: object) => {
				item['isCheck'] = false
				value.forEach(val => {
					if(item['st_fileurl'] === val.st_fileurl) {
						item['isCheck'] = true
					}
				})
			})
			checkList.forEach(check => {
				value.forEach(val => {
					if(val.st_fileurl === check.st_fileurl) {
						newCheckList.push(check)
					}
				})
			})
			setCheckList(newCheckList)
			setContentList(newContentList)
		}
	}
	useEffect(() => {
		initCkeckList()
	},[value])
	const getContentList = async (params?) => {
		let body = {}
		if(params) {
			queryBody.query = params
		}
		// 传入的内容形式 加入搜索条件
		if(JSON.stringify(queryShould) !== '{}') {
			const filter = queryBody.query.bool.filter
			let i = 0
			filter.map((item, index) => {
				if(item.bool.should) {
					i = index
				}
			})
			i === 0 ? queryBody.query.bool.filter.push(queryShould) : queryBody.query.bool.filter.splice(i, 1, queryShould)
		}
		// 不是作品
		body = queryBody
		const res = await API.getContentList(body)
		if(res.code === 0) {
			const { list, count } = res.data
			list.map((content, index) => {
				if (checkList.find(item => item.id === content.id)) {
					list[index].isCheck = true
				}
				if (accepts && accepts.length) { // 指定接收的文件类型
					const extension = UTILS.getFileExtension(content.st_fileurl)
					list[index].disabled = !accepts.includes(extension)
				}
			})
			setContentList(list.slice())
			setQueryBody(body)
			setPageTotal(count)
			// if(this.props.value) {
			// onCheck(this,this.props.value)
			// }
		}
	}
	const triggerChange = (checkList: CheckIdList): void => {
		console.log('triggerChange checkList', checkList)
		onChange ? onChange(checkList) : onSuccess(checkList)
	}
	const handleConfirm = () => {
		// if(checkList.length === 0) return
		const list = []
		checkList.forEach(item => {
			if(item.st_fileurl && item.id) {
				list.push({
					id: item.id,
					st_fileurl: item.st_fileurl,
					st_text_title: item.st_text_title,
					type: item.type,
					st_thumbnail: item.st_thumbnail
				})
			} else {
				message.error('内容没有st_fileurl，请选择其他内容')
			}
		})
		console.log('handleConfirm checkList', checkList)
		triggerChange(list)
		handleContentSelectVisible(false)
	}
	const onSearch = () => {
		// 搜索 处理 filterList
		const filter = []
		// 创建除标签以外的搜索对象
		Object.keys(initialValues).forEach(key => {
			if(initialValues[key] !== '') {
				const data = {}
				data['bool'] = {}
				data['bool']['filter'] = {}
				data['bool']['filter'][key === 'st_text_title' ? 'match' : 'term'] = {}
				data['bool']['filter'][key === 'st_text_title' ? 'match' : 'term'][key] = initialValues[key]
				filter.push(data)
			}
		})
		// console.log('filter', filter)
		// 获取标签搜索对象
		if(tagAddRef.current) {
			const condition = tagAddRef.current.getConditionList()
			if(JSON.stringify(condition) !== '{}') {
				filter.push(condition)
			}
		}
		filter.push({
			bool: {
				filter: {
					term: {
						is_del: '0'
					}
				}
			}
		},{
			bool: {
				filter: {
					term: {
						st_is_works: '0'
					}
				}
			}
		})
		const query = {
			bool: {
				filter: filter
			}
		}
		getContentList(filter.length > 0 ? query : '')
	}

	/**
	 * 重置选中状态
	 */
	const resetCheckState = () => {
		setCheckList([])
		const newContentList = [...contentList]
		newContentList.map((item, index) => newContentList[index].isCheck = false)
		setContentList(newContentList)
	}

	useEffect(() => {
		onSearch()
	},[initialValues])

	useEffect(() => {
		init()
	},[])
	useEffect(() => {
		if(JSON.stringify(queryShould) !== '{}') {
			getContentList()
		}
	},[queryShould])
	useEffect(() => {
		if (!contentSelectVisible) {
			resetCheckState() // 关闭弹窗，重置选中状态
		}
	}, [contentSelectVisible])

	const onFinish = (values: object) => {
		console.log('onFinish', values)
		setInitialValues(values)
	}
	const onFinishFailed = (errorInfo: object) => {
		console.log('Failed:', errorInfo)
	}
	const onChangePage = (page: number) => {
		queryBody.pageNo = page
		setQueryBody(queryBody)
		getContentList()

	}
	const sizeChange = (val, size) => {
		console.log(val,size)
		queryBody.size = size
		setQueryBody(queryBody)
		getContentList()
	}
	const onChangeTab = (val) => {
		generateQueryShould(val)
		queryBody.pageNo = 1
		setQueryBody(queryBody)
		getContentList()
		// setDefaultTabName(val)
	}
	const noDataNode = () => {
		return (
			<p className="empty">
				<span>暂无素材，请前往内容库添加</span>
				<Button type="link">
					<Link to="/main/content/library/index">选择文件上传</Link>
				</Button>
			</p>
		)
	}
	const renderContentSelectBlock = () => {
		return (<>
			<Form
				ref={formRef}
				className="search-bar"
				layout="inline"
				onFinish={onFinish}
				onFinishFailed={onFinishFailed}
				initialValues={initialValues}
				colon={false}
			>
				<Form.Item
					label="ID"
					name="id"
					className="label-id"
				>
					<Input/>
				</Form.Item>
				<Form.Item
					label="标题"
					name="st_text_title"
				>
					<Input/>
				</Form.Item>
				<Form.Item
					label="创建人"
					name="st_create_work">
					<Input/>
				</Form.Item>
				<div className="condition-wrap">
					<AddTag ref={tagAddRef}/>
					<Button className="fl" type="primary" htmlType="submit" style={{marginRight: '10px'}}>搜索</Button>
					<Button className="fl" onClick={onReset}>重置</Button>
				</div>
			</Form>

			<Tabs defaultActiveKey={defaultTabName} className="content-select-tab" onChange={onChangeTab}>
				{nameList.includes('图片') && <TabPane tab="图片" key="图片">
					<Row className="content-select-list clearfix" gutter={[10, 10]}>
						{contentList.length > 0 ?
							contentList.filter(item => { return idMap[item.st_type] === '图片'}).map(content => (
								<Col span={(24 / rowNum).toFixed()} key={content['id']}>
									<div className={content && content['disabled'] ? 'content-box disabled' : 'content-box'} onClick={(e) => {onCheck(e, content)}}>
										<span className={content && content['disabled'] ? 'ant-checkbox ant-checkbox-disabled' : (content && content['isCheck'] ? 'ant-checkbox ant-checkbox-checked' : 'ant-checkbox')}>
											<i className="ant-checkbox-inner"></i>
										</span>
										<div className="title">{content.isCheck}{content['st_text_title']}</div>
										<img src={idMap[content['st_type']] === '图片' ? content['st_fileurl'] : idMap[content['st_type']] === '音频' ? '//m.elongstatic.com/cdc/com-static/music.png' : content['st_thumbnail'] ? content['st_thumbnail'] : '//m.elongstatic.com/cdc/com-static/video.png'} alt={content['st_text_title']}/>
									</div>
								</Col>
							))
							: noDataNode()
						}
					</Row>

				</TabPane>}
				{nameList.includes('视频') && <TabPane tab="视频" key="视频">
					<Row className="content-select-list clearfix" gutter={[10, 10]}>
						{contentList.length > 0 ?
							contentList.filter(item => { return idMap[item.st_type] === '视频'}).map(content => (
								<Col span={(24 / rowNum).toFixed()} key={content['id']}>
									<div className={content && content['disabled'] ? 'content-box disabled' : 'content-box'} onClick={(e) => {onCheck(e, content)}}>
										<span className={content && content['disabled'] ? 'ant-checkbox ant-checkbox-disabled' : (content && content['isCheck'] ? 'ant-checkbox ant-checkbox-checked' : 'ant-checkbox')}>
											<i className="ant-checkbox-inner"></i>
										</span>
										<div className="title">{content['st_text_title']}</div>
										<img src={idMap[content['st_type']] === '图片' ? content['st_fileurl'] : idMap[content['st_type']] === '音频' ? '//m.elongstatic.com/cdc/com-static/music.png' : content['st_thumbnail'] ? content['st_thumbnail'] : '//m.elongstatic.com/cdc/com-static/video.png'} alt={content['st_text_title']}/>
									</div>
								</Col>
							))
							: noDataNode()
						}
					</Row>
				</TabPane>}
				{nameList.includes('音频') && <TabPane tab="音频" key="音频">
					<Row className="content-select-list clearfix" gutter={[10, 10]}>
						{contentList.length > 0 ?
							contentList.filter(item => { return idMap[item.st_type] === '音频'}).map(content => (
								<Col span={(24 / rowNum).toFixed()} key={content['id']}>
									<div className={content && content['disabled'] ? 'content-box disabled' : 'content-box'} onClick={(e) => {onCheck(e, content)}}>
										<span className={content && content['disabled'] ? 'ant-checkbox ant-checkbox-disabled' : (content && content['isCheck'] ? 'ant-checkbox ant-checkbox-checked' : 'ant-checkbox')}>
											<i className="ant-checkbox-inner"></i>
										</span>
										<div className="title">{content['st_text_title']}</div>
										<img src={idMap[content['st_type']] === '图片' ? content['st_fileurl'] : idMap[content['st_type']] === '音频' ? '//m.elongstatic.com/cdc/com-static/music.png' : content['st_thumbnail'] ? content['st_thumbnail'] : '//m.elongstatic.com/cdc/com-static/video.png'} alt={content['st_text_title']}/>
									</div>
								</Col>
							))
							: noDataNode()
						}
					</Row>

				</TabPane>}
			</Tabs>
			{/* 分页 */}
			{contentList.length > 0
				?
				<Pagination
					onChange={onChangePage}
					defaultPageSize={queryBody['size']}
					current={queryBody['pageNo']}
					onShowSizeChange={sizeChange}
					total={pageTotal}
				/>
				: ''
			}
		</>)
	}
	return type === 'btn' ? (
		<div className="content-select-wrap">
			<Modal
				className="content-select-box"
				title="内容库"
				visible={contentSelectVisible}
				onCancel={() => handleContentSelectVisible(false)}
				footer={[
					<Button key="confirm" type="primary" onClick={handleConfirm}>确定使用</Button>
				]}
			>
				{renderContentSelectBlock()}
			</Modal>
		</div>
	) : (
		<div className="content-select-box">
			{renderContentSelectBlock()}
			<Button style={{ marginTop: '10px' }} className="confirm-btn" key="confirm" type="primary" onClick={handleConfirm}>确定使用</Button>
		</div>
	)
}

ContentSelect.defaultProps = {
	value: [],
	nameList: [],
	handleContentSelectVisible: false,
	onSuccess: null,
	contentSelectVisible: false,
	onChange: null,
	type: 'btn',
	rowNum: 4,
	accepts: [], // 指定文件类型 扩展名
}

export default ContentSelect